var _excluded = ["children", "className", "closeDialogTooltipText", "onClose", "showCloseButton"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { func, node, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import CloseButton from "../internals/components/close-button/CloseButton";
import ButtonsGroup from "../sovos-buttons-group";
import SovosTypography from "../sovos-typography";
import useMosaicTranslation from "../internals/i18n/useMosaicTranslation";
var StyledTitle = styled('div')(function (_ref) {
  var _ref$theme = _ref.theme,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    height: spacing(6),
    justifyContent: 'space-between',
    padding: "0 0 ".concat(spacing(2), " 0"),
    '& .title': {
      color: palette.text.primary,
      flex: '1 1 auto'
    },
    '& .buttonsGroup': {
      flex: '1 1 auto'
    }
  };
});

/**
 * `SovosDialogTitle` is a component to be used inside `SovosDialog` to set
 * up a dialog title.
 */
var SovosDialogTitle = function SovosDialogTitle(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    closeDialogTooltipText = _ref2.closeDialogTooltipText,
    _onClose = _ref2.onClose,
    _ref2$showCloseButton = _ref2.showCloseButton,
    showCloseButton = _ref2$showCloseButton === void 0 ? false : _ref2$showCloseButton,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useMosaicTranslation = useMosaicTranslation(),
    t = _useMosaicTranslation.t;
  return /*#__PURE__*/React.createElement(StyledTitle, _extends({
    className: clsx('sovosDialogTitle', className)
  }, props), /*#__PURE__*/React.createElement(SovosTypography, {
    variant: "h5",
    className: "title"
  }, children), showCloseButton && _onClose ? /*#__PURE__*/React.createElement(ButtonsGroup, {
    className: "buttonsGroup",
    align: "right"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    className: "sovosDialog__closeButton",
    onClose: function onClose(e) {
      return _onClose(e, 'closebuttonClick');
    },
    tooltipText: closeDialogTooltipText || t('dialogTitle.closeDialogTooltip'),
    size: "small"
  })) : null);
};
SovosDialogTitle.propTypes = {
  /**
   * The content of the dialog title. Must be a string
   */
  children: string,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Optional tooltip text applied to the close button, when present
   */
  closeDialogTooltipText: node,
  /**
   * Callback for the close button, when present
   */
  onClose: func,
  /**
   * When true, a close button will be displayed & `onClose` is required
   */
  showCloseButton: function showCloseButton(_ref3) {
    var onClose = _ref3.onClose,
      _showCloseButton = _ref3.showCloseButton;
    if (_showCloseButton && !onClose) {
      return new Error('When showCloseButton is true, onClose callback function is required');
    }
    return null;
  }
};
export default SovosDialogTitle;